<template>
  <div class="multipleTree">
    <el-radio-group
      v-model="typeFiltering"
      @change="changetypeFiltering"
      size="small"
    >
      <el-radio-button label="分项系统">系统</el-radio-button>
      <el-radio-button label="区域位置">区域</el-radio-button>
      <el-radio-button label="单位部门">部门</el-radio-button>
    </el-radio-group>
    <el-row>
      <el-radio-group
        v-model="activeType"
        size="mini"
        style="margin-top: 20px"
        @change="getAsseList"
      >
        <el-radio v-for="v in energyTypeList" :key="v.key" :label="v.key">{{
          v.name
        }}</el-radio>
      </el-radio-group>
    </el-row>
    <div class="timeBox">
      <el-checkbox v-model="cascade" border size="mini" @change="changeCascade"
        >级联选择</el-checkbox
      >
    </div>
    <div style="width: 100%; height: 70%; margin: 10px 0 20px 0">
      <el-tree
        :data="dataList"
        :props="defaultProps"
        node-key="id"
        highlight-current
        accordion
        show-checkbox
        :check-strictly="!cascade"
        :default-expanded-keys="defaultKeys"
        @check="handleNodeClick"
        ref="tree"
        style="
          overflow: auto;
          background: #f7f7f7;
          border: 1px solid #e7e7e7;
          border-radius: 6px;
          padding: 20px 0 30px;
          margin-top: 10px;
          height: 80%;
        "
      >
      </el-tree>
    </div>
  </div>
</template>

<script>
import api from "@/api";
export default {
  data() {
    return {
      typeFiltering: "分项系统",
      defaultProps: {
        children: "children",
        label: "name",
      },
      cascade: false,
      dataList: [],
      treeAllData: {}, //全部树数据
      defaultKeys: [], //默认打开
      energyTypeList: [],
      activeType: "",
    };
  },
  watch: {},
  methods: {
    handleNodeClick() {
      let obj = this.energyTypeList.find((v) => {
        return v.key === this.activeType;
      });
      this.$emit("getTreeActive", {
        name: this.$refs.tree.getCheckedNodes(false, true),
        activeType: this.activeType,
        deviceType: obj.deviceTypes ?? "",
        allTreeData: this.dataList,
        label: this.typeFiltering,
      });
    },
    changeCascade() {
      this.$refs.tree.setCheckedKeys([]);
      this.$emit("getTreeActive", { assetId: [], name: [] });
    },

    changetypeFiltering(type) {
      this.dataList = this.treeAllData[this.typeFiltering]
        ? [this.treeAllData[this.typeFiltering]]
        : [];
      this.$refs.tree.setCheckedKeys([]);
      this.defaultKeys = [];
      if (type == "resetting" && this.dataList.length) {
        this.$nextTick(() => {
          this.$refs.tree.setCheckedKeys([this.dataList[0].id]);
          this.defaultKeys.push(this.dataList[0].id);
        });
      }
      this.$emit("getTreeActive", { assetId: [], name: [] });
    },
    async getAsseList() {
      this.$store.commit("SET_LOADING", true);
      let obj = this.energyTypeList.find((v) => {
        return v.key === this.activeType;
      });
      this.treeAllData = {};
      this.dataList = [];
      let res = await api.lightSystemAssetsTreeMenu({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        projectName: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectName,
        option: "HasEUDevice",
        deviceType: obj.deviceTypes ?? "",
        relationType: "Contains",
      });
      if (res && res.status == 200) {
        this.$store.commit("SET_LOADING", false);
        this.treeAllData = res.data.assets ?? {};
        this.dataList = this.treeAllData[this.typeFiltering]
          ? [this.treeAllData[this.typeFiltering]]
          : [];

        if (this.dataList.length) {
          this.$nextTick(() => {
            this.$refs.tree.setCheckedKeys([this.dataList[0].id]);
            this.defaultKeys.push(this.dataList[0].id);
            let data = {
              name: this.$refs.tree.getCheckedNodes(false, true),
              activeType: this.activeType,
              deviceType: obj.deviceTypes ?? "",
              allTreeData: this.dataList,
              label: this.typeFiltering,
            };
            this.$emit("getTreeActive", data);
          });
        } else {
          this.$emit("getTreeActive", { assetId: [], name: [] });
        }
      }
    },
  },
  created() {
    this.energyTypeList = JSON.parse(
      window.sessionStorage.getItem("energyType")
    );
    this.activeType = this.energyTypeList[0]?.key ?? "power";
    this.getAsseList();
  },
};
</script>

<style lang="scss" scoped>
.multipleTree {
  width: 93%;
  height: 93%;
  margin: 5% auto;
  overflow: auto;
  ::v-deep
    .el-tree--highlight-current
    .el-tree-node.is-current
    > .el-tree-node__content {
    background-color: $themeColor !important;
    color: #fff;
  }
  .timeBox {
    margin: 20px 0;
  }
  .btnBox {
    @include setFlexCenter;
  }
}
</style>
